import React from 'react';
import dayjs from 'app/libs/dayjs';
import classNames from 'classnames/bind';
import { numberWithCommas } from 'app/libs/number';
import styles from './PaymentHistoryMonthLayer.module.scss';

const cx = classNames.bind(styles);

function PaymentHistoryMonthLayer({ selectedYearMonth, quarterHistoryData = undefined, isCarryoverMonth }) {
	const { quarter, excessAmounts, quarterExcessAmount, yearMonths = [] } = quarterHistoryData || {};

	return (
		<>
			{yearMonths.map((yearMonth) => {
				const historyMoment = dayjs(yearMonth);
				const excessAmountData = excessAmounts.find((data) => yearMonth === data.useYearMonth);
				const { beforeExcessAmount, excessAmount } = excessAmountData || {};
				const isBeforeUse = historyMoment.isSameOrAfter(dayjs(selectedYearMonth));

				return (
					<dl
						key={historyMoment.month()}
						className={cx('list')}
					>
						<dt>{historyMoment.month() + 1}월 초과금액</dt>
						{isBeforeUse && <dd className={cx('before')}>이용전</dd>}
						{!isBeforeUse && (
							<dd>
								{Boolean(beforeExcessAmount) && beforeExcessAmount !== excessAmount && (
									<em className={cx('num_adjust')}>{numberWithCommas(beforeExcessAmount)}원</em>
								)}
								{numberWithCommas(excessAmount)}원
							</dd>
						)}
					</dl>
				);
			})}
			<dl className={cx('list', 'total')}>
				<dt>{quarter}분기 초과금액</dt>
				<dd>{numberWithCommas(isCarryoverMonth ? quarterExcessAmount : Math.max(quarterExcessAmount, 0))}원</dd>
			</dl>
		</>
	);
}

export default PaymentHistoryMonthLayer;
